<template>
  <a-modal
    v-model:visible="confirmVisible"
    title="确定加入全病程管理服务"
    centered
    @cancel="onCancel"
    @ok="onOk"
  >
    <div class="fullCourseConfirm">
      <div class="z-flex handle-stage handle-stage-num">
        <span class="label">患者是否加入全病程管理服务</span>
        <a-radio-group
          :options="confirmResultList"
          v-model:value="confirmQuery.courseServicesFlag"
          @change="handleChange"
        />
      </div>
      <a-textarea
        v-if="confirmQuery.courseServicesFlag === 2"
        v-model:value="confirmQuery.courseServicesCause"
        placeholder="请输入理由（选填）"
        :auto-size="{ minRows: 2, maxRows: 5 }"
        :maxlength="200"
      />
    </div>
  </a-modal>
</template>
<script setup>
import { ref, reactive, defineExpose, defineProps, defineEmits } from 'vue'
import { joinCourseServices } from '@/api/workPlace/workOrder.js'
import { useStore } from 'vuex'

const prop = defineProps({
  doctorInfo: {
    type: Object,
    default: () => {},
    require: true
  }
})
const confirmResultList = [
  { label: '是', value: 1 },
  { label: '否', value: 2 }
]

const confirmQuery = reactive({
  courseServicesCause: '',
  courseServicesFlag: null
})

function handleChange(e) {
  if (e.target.value) {
    confirmQuery.courseServicesCause = ''
  }
}

const confirmVisible = ref(false)
function onCancel() {
  confirmVisible.value = false
}

const store = useStore()
const emits = defineEmits(['completeBuss'])
const onOk = () => {
  joinCourseServices({
    ...confirmQuery,
    ucDoctorId: prop.doctorInfo.ucUserId,
    ucPatientId: store.state.workOrder.workOrderGroupInfo.patientInfo.ucUserId
  }).then(() => {
    confirmVisible.value = false
    emits('completeBuss')
  })
}
defineExpose({
  confirmVisible
})
</script>
<style scoped lang="scss">
.handle-stage {
  justify-content: flex-start;
  align-items: center;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  margin-bottom: 16px;
  &.handle-stage-num {
    margin-bottom: 22px;
  }
  .label {
    margin-right: 60px;
  }
}
</style>
